import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;1,400&family=Quicksand:wght@300;400;500;600;700&display=swap');

  :root {
    --barn-red: #8B2323;
    --barn-red-dark: #5C1616;
    --barn-red-light: #A83232;
    --wheat: #F5DEB3;
    --cream: #FDF8F0;
    --warm-white: #FEFCF8;
    --earth: #3D3225;
    --earth-light: #7A6B55;
    --sage: #87A878;
    --sage-dark: #5B7A4A;
    --pumpkin: #E07020;
    --gold: #DAA520;
    --evergreen: #2F4F2F;
    --snow: #F8F8FF;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    font-family: 'Quicksand', sans-serif;
    background: var(--earth);
    color: var(--earth);
    line-height: 1.7;
    overflow-x: hidden;
  }

  h1, h2, h3, h4 {
    font-family: 'Playfair Display', serif;
    font-weight: 600;
    line-height: 1.2;
  }

  button {
    cursor: pointer;
    border: none;
    outline: none;
    font-family: 'Quicksand', sans-serif;
  }

  a {
    text-decoration: none !important;
    color: inherit;
  }

  img {
    max-width: 100%;
    display: block;
  }

  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-track {
    background: var(--earth);
  }
  ::-webkit-scrollbar-thumb {
    background: var(--barn-red);
    border-radius: 4px;
  }
`;

export default GlobalStyles;
